// React Setup
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
  // BrowserRouter as Router,
  MemoryRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

// Apollo Setup
import { ApolloProvider } from '@apollo/client';
import getApolloClient from './lib/graphql/apolloClient';

// Route Security
import { QuantaSecureRoute } from 'quanta-flows';

// Flow Configuration
import { QuantaCache, QuantaRoutes } from 'quanta-flows';

// Quanta Provider
import { QuantaThemeProvider } from 'quanta-ui';

// Configurations
import { QuantaConfigProvider } from 'quanta-flows';
import branding from './config/branding.config';
import quote_products from './config/quote_products.config';
import theme from './config/theme.config';

import reportWebVitals from './reportWebVitals';

// Enable Application Theme
import './styles/enable-roboto.css';
import './styles/theme.css';
import './styles/style.css';

// Import Custom Caches and Routes
import { mergeCache, mergeRoutes } from 'quanta-flows';
import gistQuoteRoute from './modules/quote/_routes';

import { Loading } from 'quanta-flows/modules/layout';
require('dotenv').config();

// Create Custom Cache and Routes by merging with Quanta Cache and Routes
//const gistQuantaCache = mergeCache(QuantaCache);
const gistQuantaRoutes = mergeRoutes(gistQuoteRoute, QuantaRoutes);

const renderRoutes = (routes) =>
  routes.map(({ secure, ...params }, idx) => {
    const ThisRoute = secure ? QuantaSecureRoute : Route;
    return <ThisRoute key={idx} {...params} />;
  });

ReactDOM.render(
  <QuantaThemeProvider defaultTheme="alpha">
    <Router>
      <Suspense fallback={<Loading />}>
      <ApolloProvider client={getApolloClient(QuantaCache)}>
        <QuantaConfigProvider
          {...{
            branding,
            quote_products,
            theme,
            routes: gistQuantaRoutes,
          }}
        >
          <Switch>{renderRoutes(gistQuantaRoutes)}</Switch>
        </QuantaConfigProvider>
      </ApolloProvider>
      </Suspense>
    </Router>
  </QuantaThemeProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
